import { render, staticRenderFns } from "./patients.table.vue?vue&type=template&id=3e7c69ea&scoped=true&"
import script from "./patients.table.vue?vue&type=script&lang=js&"
export * from "./patients.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7c69ea",
  null
  
)

export default component.exports